export const Fonts = {
	MICR: {
		normal: 'MICR-Regular.ttf',
	},
	Roboto: {
		bold: 'Roboto-Medium.ttf',
		italic: 'Roboto-Italic.ttf',
		normal: 'Roboto-Regular.ttf',
	}
};